import { createGlobalStyle } from 'styled-components';

const fontUrl =
  '//www.zillowstatic.com/s3/constellation-website/public/shared/fonts/open-sans/latest/open-sans-variable.woff2';

export const Baseline = createGlobalStyle`
  @font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url(${fontUrl}) format('woff2');
  }
  
  html {
    box-sizing: border-box;
    ${(props) => props.theme.fonts.defaultFamily};
  }
  
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  
  body {
    ${(props) => props.theme.fonts.mixins.body};
    background-color: ${(props) => props.theme.colors.defaultBackground};
    color: ${(props) => props.theme.colors.defaultContentText};
    margin: 0;
    padding: 0;
  }
`;
